import * as signalR from '@microsoft/signalr';
import { Authorization, formatDate, notifyInfo, toId } from '@serenity-is/corelib';

export class NotificationHandler {
    static instance: NotificationHandler;
    private notificationContainer: HTMLElement;
    private notificationCount?: number = null;

    public static init() {
        if (!Authorization.isLoggedIn)
            return;
        this.instance = new NotificationHandler();
    }

    connection: signalR.HubConnection;
    constructor() {
        this.connection = new signalR.HubConnectionBuilder().withUrl("/connect/notification").build();
        this.connection.on("ReceiveNotification", async (message) => this.receiveNotification(message));
        this.connection.on("TakeNotifications", async (message) => this.updateNotificationCounter(message));
        this.connection.start().catch(err => console.error(err.toString()));
        this.notificationContainer = document.querySelector("#notifications-content > .cardx > .card-bodyx > .list-group");
        setInterval(() => this.connection.invoke("GetUnreadNotifications"), 10000);
    }

    public receiveNotification(notification: NotificationModel) {
        var notificationItem = this.createNotificationItem(notification);
        this.notificationContainer.prepend(notificationItem)
        this.markAsRead(notification)
    }

    public markAsRead(notification: NotificationModel) {
        //this.connection.invoke("ReadNotification", notification.notificationId).catch(err => console.error(err.toString()));
        //notificationItem.classList.remove("bg-warning");
    }

    public createNotificationItem(notification: NotificationModel) {
        return <li
            class={"border-bottom " + (notification.isRead == "1" ? "" : "bg-warning")}
            data-item-id={notification.notificationId}
        >
            <span class="btn btn-warning btn-sm"><i class="fa fa-check-double"></i></span><span> {formatDate(notification.messageTime)} - {notification.message}</span>
            
        </li>
    }

    public updateNotificationCounter(response: NotificationCountModel) {
        var element = document.querySelector("[data-content-id='notifications-content'] > span") as HTMLSpanElement;
        element.innerText = response.notificationCount?.toString();

        if (this.notificationCount != null && this.notificationCount != response.notificationCount) {
            notifyInfo("You have " + response.notificationCount + " new notifications", "Notifications", {
                positionClass: "toast-bottom-right",
                timeOut: 5000
            });
        }

        this.notificationCount = response.notificationCount; 
    }
}

export type NotificationCountModel = {
    notificationCount: number,
    reminderCount: number,
    taskCount: number
}

export type NotificationModel = {
    notificationId: number;
    category: string;
    message: string;
    messageTime: Date;
    isRead: string;
}

NotificationHandler.init();